import Vue from 'vue';
import Router from 'vue-router';
import * as firebase from 'firebase/app';
import 'firebase/auth';

import HomeLayout from '@/layouts/home.vue';
import Home       from '@/views/Home.vue';


Vue.use(Router);

function requireAuth(to, from, next) {
  if (!firebase.auth().currentUser) {
      next('/account/signin');
  } else {
      next();
  }
}

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    { path: '/', component: HomeLayout,
      children: [
        { path: '', redirect: { name: 'sign-in'} },
        { path: 'marketing', name: 'home', component: Home },
        { path: 'go', name: 'getting-started',            component: () => import(/* webpackChunkName: "home" */ '@/views/getstarted.vue'), },
        { path: 'terms', beforeEnter(to, from, next) { window.location.href = 'https://getquizme.com/blog/terms' } },
        { path: 'terms/privacy', beforeEnter(to, from, next) { window.location.href = 'https://getquizme.com/blog/privacy' } },
        { path: 'privacy', beforeEnter(to, from, next) { window.location.href = 'https://getquizme.com/blog/privacy' } },
      ],
    },
    { path: '/app',
      component: () => import(/* webpackChunkName: "app-layout" */ '@/layouts/inapp.vue'),
      children: [
        { path: '', name: 'app-home', component: () => import(/* webpackChunkName: "app-home" */ '@/views/app/app-home.vue'),
            meta: { breadcrumb: [{ name: 'Home' }] } },
        { path: 'welcome', name: 'app-welcome',             component: () => import(/* webpackChunkName: "welcome" */ '@/views/app/welcome/welcome-home.vue'), },
        { path: 'welcome/intro', name: 'app-welcome-intro', component: () => import(/* webpackChunkName: "welcome" */ '@/views/app/welcome/welcome-intro.vue'), },
        { path: 'welcome/learn', name: 'app-welcome-learn', component: () => import(/* webpackChunkName: "welcome" */ '@/views/app/welcome/welcome-learn.vue'), },
        { path: 'welcome/trial', name: 'app-welcome-trail', component: () => import(/* webpackChunkName: "welcome" */ '@/views/app/welcome/welcome-trial.vue'), },
        { path: 'explore', name: 'app-explore-decks',       component: () => import(/* webpackChunkName: "decks" */ '@/views/app/explore.vue'), },
        { path: 'user/profile', name: 'user-profile',       component: () => import(/* webpackChunkName: "user" */ '@/views/app/users/user-profile.vue') },
        { path: 'deck/:id', name: 'deck-details',           component: () => import(/* webpackChunkName: "decks" */ '@/views/app/decks/deck-details.vue'),
          meta: { breadcrumb: [{ name: 'Home', namedLink: 'app-home'}, { name: 'Deck' } ] },
        },
        { path: 'deck/:id/edit', name: 'deck-edit', component: () => import(/* webpackChunkName: "decks" */ '@/views/app/decks/deck-edit.vue'),
            meta: { breadcrumb: [{ name: 'Home', namedLink: 'app-home'}, { name: 'Deck', namedLink: 'deck-details'}, { name: 'Edit Deck' } ] },
        },
        { path: 'deck/:id/learn', name: 'deck-learn', component: () => import(/* webpackChunkName: "decks" */ '@/views/app/decks/deck-learn.vue'),
          meta: { breadcrumb: [{ name: 'Home', namedLink: 'app-home'}, { name: 'Deck', namedLink: 'deck-details'}, { name: 'Learn Deck' } ] },
        },
      ],
      beforeEnter: requireAuth,
    },
    { path: '/account', name: 'account-details', 
      component: () => import(/* webpackChunkName: "about" */ '@/layouts/fullscreen.vue'),
      children: [
        { path: 'checkout', name: 'app-checkout',   component: () => import(/* webpackChunkName: "account" */ '@/views/app/account/checkout.vue'), beforeEnter: requireAuth, },
        { path: 'signin', name: 'sign-in',   component: () => import(/* webpackChunkName: "home" */ '@/views/signin.vue'), },
        { path: 'magic-link', name: 'magic-link',   component: () => import(/* webpackChunkName: "home" */ '@/views/app/account/magic-link.vue'), },
      ],
    },
    { path: '/about', name: 'about', 
      component: () => import(/* webpackChunkName: "about" */ '@/layouts/inapp.vue'),
      children: [
        { path: 'help', name: 'app-help',   component: () => import(/* webpackChunkName: "terms" */ '@/views/help.vue'), },
      ],
    },
    { path: '*', component: () => import(/* webpackChunkName: "privacy" */ '@/layouts/inapp.vue'), children: [{ path: '', component: () => import(/* webpackChunkName: "404" */ '@/components/404.vue'), }] },
  ],
});
